import {Component, OnInit, ViewChild} from '@angular/core';
import {ExgDataTableComponent, ExgModalService} from 'exc-controls-v2';
import {ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcTranslation} from 'exc-core-v2';

@Component({
  selector: 'app-modal-oe-list',
  templateUrl: './modal-oe-list.component.html',
  styles: [
  ]
})
export class ModalOeListComponent extends ExcTranslation implements OnInit {
  @ViewChild('VCoeUserList', {read: ExgDataTableComponent}) VCoeUserList!: ExgDataTableComponent;

  data = {} as any;
  init = true;

  oeUserList = {
    data: [] as any,
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
    } as IExcMetaInfo,
    paging: {
      pagingPage: 0,
      pagingEndRow: 0,
      pagingPageSize: 25,
      pagingTotalPages: 0,
      pagingTotalRows: 0,
      pagingStartRow: 0,
    },
    isLoading: true,

    selectKey: 'oeID',
    state: 1,
    selectedRow: undefined as any,
    searchValue: '',
    uiFilter: [] as any[],
    uiSort: [] as any[],
    ready: () => {
      if (!this.oeUserList.data || this.oeUserList.data.length === 0) {
        this.oeUserList.state = 2;
        this.VCoeUserList.selectedRow = -1;
      } else {
        this.oeUserList.state = 0;
        this.VCoeUserList.selectedRow = 0;
      }
      this.init = false;
    },
    selectionChanged: (index: number) => {
      this.oeUserList.selectedRow = this.oeUserList.data[index];
    },
    pageChanged: (page: number) => {
      if (this.oeUserList.MetaInfo.dataPaging !== undefined) {
        this.oeUserList.MetaInfo.dataPaging.pageNo = page;
      }
      this.oeUserList.loadData();
    },
    search: (value: string) => {
      this.oeUserList.searchValue = value;
      this.oeUserList.pageChanged(1);
    },
    loadData: () => {
      const SELF = this;
      SELF.oeUserList.state = 1;
      SELF.oeUserList.isLoading = true;
      SELF.excRestService
        .get(
          SELF.excRestService.computeUrl(
            'OECompanyRListTyp', {
              fts: this.oeUserList.searchValue,
          }),
          {MetaInfo: SELF.oeUserList.MetaInfo}
        )
        .subscribe((response) => {
          if (response.success && response.data) {
            SELF.oeUserList.data = response.data;
            SELF.oeUserList.paging = response.paging;
          } else {
            SELF.oeUserList.data = [];
            SELF.oeUserList.paging = {
              pagingPage: 0,
              pagingEndRow: 0,
              pagingPageSize: 25,
              pagingTotalPages: 0,
              pagingTotalRows: 0,
              pagingStartRow: 0,
            };
          }
          SELF.oeUserList.ready();
          SELF.oeUserList.isLoading = false;
        });
    }
  };

  constructor(
    public excRestService: ExcRestService,
    public modal: ExgModalService,
    public enumSvc: EnumerationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initialize();
  }

  initialize(): void {
    this.oeUserList.loadData();
  }

  clickedSave(): void {
    this.modal.action(this.oeUserList.selectedRow);
  }

  clickedCancel(): void {
    this.modal.close();
  }
}
